import "./testimonial.scss";

import Slider from "react-slick";
import themeConfig from "@src/configs/theme-config";

const testimonials = [
    {
        text   : `As a SaaS company with multiple product lines and legal entities, ${themeConfig.app.name} has been a lifesaver. It gave us a single source of truth and removed the friction from day-to-day operations.`,
        name   : "Subhomoy Naskar: Director of Customer Success",
        company: "Affnook",
        image  : `${themeConfig.bucketImgCdnURL}/auth/testimonials/shubhmoy.png`
    },
    {
        text   : "The interface is so intuitive that our entire team was onboarded in just one day. We finally feel in control of our operations",
        name   : "Anchal Siwag: Director of Customer Success",
        company: "Apptrove",
        image  : `${themeConfig.bucketImgCdnURL}/auth/testimonials/anchal.jpeg`
    },
    {
        text   : "Simple, powerful, and fast. We migrated our data in one day and haven’t looked back.",
        name   : "Faizan: CEO",
        company: "Trackier",
        image  : `${themeConfig.bucketImgCdnURL}/auth/testimonials/faizan.png`
    }
];

const TestimonialSlider = () => {
    const settings = {
        dots          : true,
        infinite      : true,
        speed         : 500,
        arrows        : false,
        autoplay      : true,
        autoplaySpeed : 4000,
        slidesToShow  : 1,
        slidesToScroll: 1
    };

    return (
        <div className="testimonial-slider container my-5">
            <Slider {...settings}>
                {testimonials.map((item, index) => (
                    <div key={index} className="testimonial-card p-4 rounded">
                        <div className="quote-icon text-primary">❝</div>
                        <p className="testimonial-text">{item.text}</p>
                        <div className="d-flex align-items-center mt-4">
                            <img
                                src={item.image}
                                alt={item.name}
                                className="rounded-circle me-3"
                                width="50"
                                height="50"/>
                            <div>
                                <h6 className="mb-0">{item.name}</h6>
                                <small className="text-muted">{item.company}</small>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default TestimonialSlider;
